import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  errorContainer: { alignItems: 'center', flex: 1, justifyContent: 'center' },
  errorData: { flex: 1, justifyContent: 'center' },
});
export default styles;
